import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';
import { DefaultQuestsSubLayout } from 'Layouts/Quests/DefaultQuestsSubLayout';
import { EventQuestsSubLayout } from './EventQuestsSubLayout';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '3c36c07d-e0e0-4bdc-aaa3-abae8822baf9',
      type: 'Layout',
      name: 'subLayout',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/DefaultQuestsSubLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: -180,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'a54a3807-8666-41f6-bc4b-06501c683664',
      type: 'Layout',
      name: 'eventSubLayout',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/EventQuestsSubLayout.ts',
      percentX: 0,
      percentY: 0,
      x: -510,
      y: -33,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class EventQuestsPopupLayout {
  static raw = raw;
  root: PIXI.Container
  subLayout: DefaultQuestsSubLayout
  eventSubLayout: EventQuestsSubLayout

  constructor() {
    populate(this, raw);
  }
}
